import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import employees from '../data/employees';
import backgroundImage from '../data/bg3.jpg';

const EmployeePage = () => {
  const { id } = useParams();
  const employee = employees.find((e) => e.id === id);

  const [selectedImage, setSelectedImage] = useState(null);
  const closeModal = () => setSelectedImage(null);

  if (!employee)
    return (
      <p style={{ color: 'white', padding: '20px' }}>
        Oops, couldn't find that team member 😢
      </p>
    );

  return (
    <div
      style={{
              backgroundImage: `url(${backgroundImage})`, // ✅ Background Image
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              minHeight: '100vh',
              width: '100%',
            }}
    >
      {/* Back Link */}
      <div style={{ position: 'absolute', top: '20px', left: '20px' }}>
        <Link
          to="/"
          style={{
            color: '#ffb6c1',
            textDecoration: 'none',
            fontSize: '18px',
          }}
        >
          ← Back to Models
        </Link>
      </div>

      {/* Header ❀ {employee.name} ✧・ﾟ:*☆ * */}
      <div style={{ textAlign: 'center', marginBottom: '30px' }}>
        <h1 style={{ fontSize: '38px', color: '#ffb6c1' }}>
          ✧ {employee.name} ✧
        </h1>
        {/* <p style={{ color: '#fcd1dc' }}>
          ♡ Discover beauty & charm ♡
        </p> */}
      </div>

      {/* Profile Section */}
      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
        <img
          src={employee.images[0]}
          alt={employee.name}
          style={{
            width: '160px',
            height: '160px',
            objectFit: 'cover',
            borderRadius: '50%',
            border: '4px solid #ffb6c1',
            boxShadow: '0 0 15px rgba(255, 182, 193, 0.6)',
            marginBottom: '20px',
          }}
        />
      </div>

      {/* Personal Info Section */}
      <div
        style={{
          backgroundColor: '#fff0f5',
          color: '#222',
          borderRadius: '12px',
          padding: '25px',
          maxWidth: '600px',
          margin: '0 auto 40px',
          boxShadow: '0 4px 12px rgba(255,182,193,0.3)',
        }}
      >
        <h2 style={{ color: '#cc3366', marginBottom: '20px', textAlign: 'center' }}>
          ☆ Details ☆
        </h2>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 2fr',
            gap: '24px 24px',
            fontSize: '16px',
          }}
        >
          <div><strong>Height</strong></div>
          <div>{employee.height || 'N/A'}</div>

          <div><strong>Weight</strong></div>
          <div>{employee.weight || 'N/A'}</div>

          <div><strong>Measurement</strong></div>
          <div>{employee.measurement || 'N/A'}</div>

          <div><strong>Services</strong></div>
          <div>{employee.services || 'N/A'}</div>

        </div>
      </div>

      {/* Introduction Section */}
      <div
        style={{
          backgroundColor: '#fff0f5',
          color: '#222',
          borderRadius: '12px',
          padding: '25px',
          maxWidth: '600px',
          margin: '0 auto 40px',
          fontSize: '16px',
          lineHeight: '1.7',
        }}
      >
        <h2 style={{ color: '#cc3366', marginBottom: '10px', textAlign: 'center' }}>
          ❀ Introduction ❀
        </h2>
        <p>{employee.introduction || '暂无介绍'}</p>
      </div>

      {/* Photo Gallery Section */}
      <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
        <h2 style={{ textAlign: 'center', color: '#ffb6c1', marginBottom: '20px' }}>
          ♡ Gallery ♡
        </h2>
        <div style={{ overflowX: 'auto', paddingBottom: '10px' }}>
          <div
            style={{
              display: 'flex',
              gap: '15px',
              padding: '10px',
            }}
          >
            {employee.images.map((img, idx) => (
              <img
                key={idx}
                src={img}
                alt={`${employee.name} ${idx + 1}`}
                onClick={() => setSelectedImage(img)}
                style={{
                  cursor: 'pointer',
                  width: '160px',
                  height: '200px',
                  objectFit: 'cover',
                  borderRadius: '10px',
                  border: '2px solid #ffc0cb',
                  boxShadow: '0 2px 10px rgba(255,182,193,0.3)',
                  flexShrink: 0,
                }}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <div
        style={{
          backgroundColor: '#000',
          color: '#222',
          borderRadius: '12px',
          padding: '25px',
          paddingTop: '40px',
          maxWidth: '600px',
          margin: '0 auto 40px',
        }}
      >
        <h2 style={{ color: 'lime', marginBottom: '15px', textAlign: 'center' }}>
          ✦ Contact ✦
        </h2>
        <h2 style={{ fontSize: '30px', color: 'lime', textAlign: 'center'}}>437-216-6181</h2>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          onClick={closeModal}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 999,
          }}
        >
          <img
            src={selectedImage}
            alt="Full View"
            style={{ maxHeight: '90vh', maxWidth: '90vw', borderRadius: '10px' }}
          />
        </div>
      )}
    </div>
  );
};

export default EmployeePage;
